export const RESULT_OF_STOP = [
  {
    value: 'VERBAL_WARNING',
    label: 'Verbal Warning',
  },
  {
    value: 'WRITTEN_WARNING',
    label: 'Written Warning',
  },
  {
    value: 'WRITTEN_WARNING_AND_ARREST',
    label: 'Written Warning and Arrest',
  },
  {
    value: 'CITATION_AND_ARREST',
    label: 'Citation and Arrest',
  },
  {
    value: 'CITATION',
    label: 'Citation',
  },
  {
    value: 'ARREST',
    label: 'Arrest',
  },
] as const;
